import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DownloadButtonComponent } from '../download-button/download-button.component';

@Component({
  selector: 'app-convert-button',
  standalone: true,
  templateUrl: './convert-button.component.html',
  styleUrls: ['./convert-button.component.css'],
  // template: `
  //   <button  id="file-upload" style="display:none;" class="btn btn-success btn-block" (click)="convertFile()" [disabled]="!file">
  //     Convert
  //   </button>
  // `,
  styles: [`
    .btn-block {
      width: 100%;
      padding: 10px;
    }
  `]
})
export class ConvertButtonComponent {
  @Input() file!: File;
  @Output() convert = new EventEmitter<void>();
 
  convertFile(): void {
   
    this.convert.emit();
  }
}
